<template>
  <div>
    <div style="position: relative">
      <a-menu :defaultSelectedKeys="['info']" mode="horizontal">
        <a-menu-item key="info">
          <a-icon type="file-text"/>
          型录锚点
        </a-menu-item>
      </a-menu>
      <a-space style="position: absolute;right: 8px;top: 8px;">
        <a-button @click="()=>{$router.go(-1)}">
          {{ $t('BACK') || '返回' }}
        </a-button>
      </a-space>
      <div class="border-content">
        <div class="middle-content">
          <div class="left-poster">
            <a-popconfirm
              class="popconfirm"
              id= "popconfirm"
              title="确定要向该点放置?"
              :visible="popconfirmVisible"
              ok-text="Yes"
              cancel-text="No"
              @confirm="confirm"
              @cancel="cancel">
            </a-popconfirm>
            <img
              @click="getMouseXY($event)"
              slot="cover"
              ref="img"
              alt="example"
              class="cover-img"
              :src="form.data.coverPath"/>
            <div v-for="item in pointTable.data" :key="item.id" id="dev1" >
              <div :style="calcStylePoint(item)" v-if="item.position === 'right'">
                <div class="point-item"></div>
              </div>
              <div :style="calcStylePoint(item)" v-if="item.position === 'left'" >
                <div class="point-item-left"></div>
              </div>
            </div>
          </div>
          <div class="right-table">
            <a-card :title="'锚点数据'"  style="margin-left:20px; ">
              <a-table :data-source="pointTable.data" row-key="id">
                <a slot="name" slot-scope="text">{{ text }}</a>
                <a-table-column
                  data-index="image"
                  align='center'
                  title="图片"
                  width="120">
                  <template slot-scope="text, record">
                    <a-avatar :src="record.image" ></a-avatar>
                  </template>
                </a-table-column>
                <a-table-column
                  data-index="position"
                  title="方向"
                  align='center'>
                </a-table-column>
                <a-table-column
                  data-index="offsetxPer"
                  title="描点X位置"
                  align='center'
                  width="120">
                </a-table-column>
                <a-table-column
                  data-index="offsetyPer"
                  title="描点Y位置"
                  width="120"/>
                <a-table-column
                  data-index="date"
                  :title="$t('OPERATION')||'操作'">
                  <template slot-scope="text, record">
                    <a-button
                      type="link"
                      @click="deleteLookBookPoint(record.id)">{{ $t('REMOVE') || '删除' }}
                    </a-button>
                  </template>
                </a-table-column>
              </a-table>
            </a-card>
          </div>
        </div>
      </div>
    </div>
    <a-modal
      :visible="goodsSelectForm.visible"
      title="图片添加"
      width="40%"
      :destroyOnClose="true"
      @ok="handleGoodsSelectOk"
      @cancel="handleGoodsSelectCancel">
      <a-form-model :model="currentDiv" :rules="rules" ref="posterPointForm">
        <a-form-model-item  label="锚点位置"  prop="position">
          <a-select v-model="currentDiv.position">
            <a-select-option key="1" value="left">左侧</a-select-option>
            <a-select-option key="2" value="right">右侧</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="图片" >
            <div style="object-fit: cover">
              <simple-uploader-s3 v-model="currentDiv.image"/>
            </div>
        </a-form-model-item>
        <a-form-model-item label="宽" >
          <a-input v-model="currentDiv.width"></a-input>
        </a-form-model-item>
        <a-form-model-item label="高" >
          <a-input v-model="currentDiv.height"></a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  _queryStory,
} from '@/api/websiteStoryApi.js';
import {
  _queryPoints,
  _deletePoints,
  _addPoints
} from '@/api/websiteStoryPointsApi.js';
import SimpleUploader from '../../../components/SimpleUploader.vue';
import SimpleUploaderS3 from '@/components/SimpleUploaderS3.vue';

function closeForm() {
  this.configForm.visible = false;
}

async function getStoryInfo() {
  const result = await _queryStory(this.storyId);
  if (result) {
    this.form.data.coverPath = result.image;
    await this.getPointsList();
  }
}

function getMouseXY(e) {
  console.log('e is', e)
  const offsetX = e.offsetX
  const offsetY = e.offsetY

  const PicWith = e.target.offsetWidth
  const PicHeight = e.target.offsetHeight
  const Posxper = (offsetX / PicWith).toFixed(2)
  const Posyper = (offsetY / PicHeight).toFixed(2)

  this.createDivDom(Posxper, Posyper, 'right')

  this.currentDiv.posPertange = []
  this.currentDiv.posPertange.push(Posxper, Posyper)

  var popConfrimDiv = document.getElementById('popconfirm')

  popConfrimDiv.style.top = offsetY + 'px'
  popConfrimDiv.style.left = offsetX + 'px'
  popConfrimDiv.style.position = 'absolute'
  this.popconfirmVisible = true
}

function handleGoodsSelectCancel() {
  this.goodsSelectForm.visible = false;
  this.getPointsList();
}

async function getPointsList() {
  if (this.storyId && this.form.data.coverPath) {
    const result = await _queryPoints(this.storyId);
    if (result) {
      this.pointTable.data = result
      this.coverImg.width = this.$refs.img.width
      this.coverImg.height = this.$refs.img.height
      this.$forceUpdate()
    }
  }
}

async function deleteLookBookPoint(relationId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      const result = await _deletePoints(relationId);
      if (result) {
        this.$message.success('删除成功');
        await this.getPointsList();
      }
    },
  });
}

function calcStylePoint(item) {
  const style = {}
  style.position = 'absolute'
  style.display = 'flex'
  // style.height = 30 + 'px'
  style.alignItems = 'center'

  style.top = (502 * parseFloat(item.offsetyPer)) + 'px'
  if (item.position === 'right') {
    style.right = (740 - 740 * parseFloat(item.offsetxPer)) + 'px'
  } else {
    style.left = 740 * parseFloat(item.offsetxPer) + 'px'
  }
  return style;
}

function createDivDom(offsetX, offsetY, position) {
  const templateDiv = {
    // position: position,
    offsetyPer: offsetY,
    offsetxPer: offsetX,
    id: offsetX + '-' + offsetY,
    // coverPath: ''
  }
  this.pointTable.data.push(templateDiv)
}

async function handleGoodsSelectOk() {
  const result = _addPoints(this.storyId, {
    offsetxPer: this.currentDiv.posPertange[0],
    offsetyPer: this.currentDiv.posPertange[1],
    height: this.currentDiv.height,
    width: this.currentDiv.width,
    image: this.currentDiv.image,
    position: this.currentDiv.position,
  })
  if (result) {
    this.goodsSelectForm.visible = false
    this.$message.info('标记添加成功')
    this.currentDiv = []
    await this.getPointsList()
  }
}

export default {
  name: 'StoryPositions',
  components: {
    SimpleUploaderS3,
  },
  props: {
    storyId: String,
  },
  data() {
    return {
      goodsSelectForm: {
        visible: false,
      },
      currentDiv: {
        elementObj: null,
        posPertange: [],
        position: 'left',
        width: '',
        height: '',
        image: '',
      },
      rules: {
        position: [{ required: true, trigger: 'blur' }],
      },
      popconfirmVisible: false,

      coverImg: {
        width: 0,
        height: 0,
      },
      // 已存在的标签Id
      posDivIdList: [],
      form: {
        data: {
          name: '',
          coverPath: '',
          nameEn: '',
          description: '',
        },
        visible: false,
      },
      pointTable: {
        data: [],
      },
    };
  },
  methods: {
    closeForm,
    getStoryInfo,
    handleGoodsSelectOk,
    handleGoodsSelectCancel,
    getPointsList,
    createDivDom,
    getMouseXY,
    deleteLookBookPoint,
    calcStylePoint,
    // calcStyleLine,
    confirm() {
      this.popconfirmVisible = false
      this.goodsSelectForm.visible = true
    },
    cancel() {
      this.popconfirmVisible = false
      this.getPointsList()
    }
  },
  async created() {
    if (this.storyId) {
      await this.getStoryInfo();
    }
  },
};
</script>

<style lang="less" scoped>

.popconfirm{
  position: absolute;
  left: 200px;
  top:200px;
}

.middle-content{
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
}

.left-poster{
  width: 750px;
  height: 510px;
  overflow: hidden;
  box-sizing: content-box;
  position: relative;

  .cover-img{
    width: 740px;
    object-fit: cover;
    height: 502px;
  }
}

.point-line{
  .font-div-left {
    font-size: 10px;
    font-family: FZLTHPro--GB1-4, FZLTHPro--GB1;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 30px;
    padding-left: 10px;
  }

  .font-div-right {
    font-size: 10px;
    font-family: FZLTHPro--GB1-4, FZLTHPro--GB1;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 30px;
    padding-left: 10px;

  }

}

.font-span {
  display: inline-block;
  white-space:nowrap;
  font-family: FZLTHPro--GB1-4, FZLTHPro--GB1;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100px;
  color: #fff;
  height: 11px;
  line-height: 100%;
  font-size: 10px;
  margin-left: 10px;
  font-size: 10px;

}

.font-span-left {
  display: inline-block;
  white-space:nowrap;
  font-family: FZLTHPro--GB1-4, FZLTHPro--GB1;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100px;
  color: #fff;
  height: 11px;
  margin-left: 10px;
  line-height: 11px;

  font-size: 10px;

}

.point-item{
  width: 4px;
  height: 5px;
  display: inline-block;
  background-color: black;
}

.point-item-left{
  //margin-left: 10px;
  width: 4px;
  height: 5px;
  display: inline-block;
  background-color: black;
}

.right-table{
  width: calc(100% - 750px);

}

.point-span {

  clip-path: polygon(5% 0%,100% 0%,95% 100%,0% 100%);
  background-color: rgba(0,0,0,0.5);
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 10px;
  padding-right: 13px;
  img {
    width: 11px;
    height: 3px;
    margin-left: 19px;
    color: #fff;

  }

}

.right-pos {
  margin-left: 5px;
}
.left-pos {
  margin-right: 5px;
}

</style>
